import { render, staticRenderFns } from "./ProjectsKanbanView.vue?vue&type=template&id=1a1b65d1"
import script from "./ProjectsKanbanView.vue?vue&type=script&lang=js"
export * from "./ProjectsKanbanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports